<div class="sidebar-wrapper">
    <h2>API Keys for {{ client.name }}</h2>

    @if (isLoading) {
        <div class="loading-container">
            <mat-spinner diameter="40"></mat-spinner>
            <p>Loading API keys...</p>
    </div>
    }

    @if (!isLoading) {
        <div>
            <h3>API Keys</h3>
            <table #apiKeysTable [dataSource]="apiKeys" class="mat-elevation-z8 full-width" mat-table>
                <!-- Name Column -->
                <ng-container matColumnDef="name">
                    <th *matHeaderCellDef mat-header-cell> Name</th>
                    <td *matCellDef="let element" mat-cell> {{ element.name }}</td>
                </ng-container>
                <!-- Permissions Column -->
                <ng-container matColumnDef="permissions">
                    <th *matHeaderCellDef mat-header-cell> Permissions</th>
                    <td *matCellDef="let element" mat-cell> {{ getPermissionsLabel(element.permissions) }}</td>
                </ng-container>
                <!-- Created Column -->
                <ng-container matColumnDef="createdAt">
                    <th *matHeaderCellDef mat-header-cell> Created</th>
                    <td *matCellDef="let element" mat-cell> {{ element.createdAt | date:'short' }}</td>
                </ng-container>
                <!-- Expires Column -->
                <ng-container matColumnDef="expiresAt">
                    <th *matHeaderCellDef mat-header-cell> Expires</th>
                    <td *matCellDef="let element" mat-cell>
                        @if (element.expiresAt) {
                            {{ element.expiresAt | date:'short' }}
                        } @else {
                            <span class="muted">Never</span>
                        }
                    </td>
                </ng-container>
                <!-- Status Column -->
                <ng-container matColumnDef="status">
                    <th *matHeaderCellDef mat-header-cell> Status</th>
                    <td *matCellDef="let element" mat-cell>
                        <div class="status-indicator">
                            <span [style.background-color]="getStatusColor(element)" class="status-dot"></span>
                            <span>{{ getStatusLabel(element) }}</span>
                        </div>
                    </td>
                </ng-container>
                <!-- Actions Column -->
                <ng-container matColumnDef="actions">
                    <th *matHeaderCellDef mat-header-cell> Actions</th>
                    <td *matCellDef="let element" mat-cell>
                        <button (click)="removeKey(element.id)" color="warn" mat-icon-button matTooltip="Remove">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </td>
                </ng-container>
                <tr *matHeaderRowDef="apiKeysColumns" mat-header-row></tr>
                <tr *matRowDef="let row; columns: apiKeysColumns;" mat-row></tr>
                <!-- No Data Row -->
                <tr *matNoDataRow class="mat-row">
                    <td class="mat-cell" colspan="6">No API keys found</td>
                </tr>
            </table>
            <!-- Add API Key Section -->
            <mat-expansion-panel class="mt-4">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        Add Shine API Key
                    </mat-panel-title>
                    <mat-panel-description>
                        Create a new API key for this client
                    </mat-panel-description>
                </mat-expansion-panel-header>
                <form (ngSubmit)="addKey()" [formGroup]="addKeyForm">
                    <div class="add-key">
                        <mat-form-field appearance="fill" class="full-width">
                            <mat-label>API Key Name</mat-label>
                            <input formControlName="keyName" matInput placeholder="Enter a descriptive name">
                            @if (addKeyForm.get('keyName')?.hasError('required')) {
                                <mat-error>
                                    API Key Name is required
                                </mat-error>
                            }
                            @if (addKeyForm.get('keyName')?.hasError('maxlength')) {
                                <mat-error>
                                    API Key Name cannot exceed 50 characters
                                </mat-error>
                            }
                        </mat-form-field>
                        <div class="form-actions">
                            <button [disabled]="isAdding || addKeyForm.invalid" color="primary" mat-raised-button
                                    type="submit">
                                {{ isAdding ? 'Creating...' : 'Create API Key' }}
                            </button>
                        </div>
                    </div>
                </form>
            </mat-expansion-panel>
            <!-- Instructions -->
            <div class="instructions mt-4">
                <h3>Usage Instructions</h3>
                <p>API keys authenticate requests to Shine services. Store them securely and rotate them if exposed.</p>
                <p>Include the API key in the <code>X-API-KEY</code> header when calling any Shine API.</p>
                <p>If an endpoint includes a <code>clientId</code> path or query parameter, it must match the key's
                    client.</p>
                <h4>External Providers</h4>
                <p>External provider credentials (OpenAI, Azure, etc.) are managed in the Connections tab.</p>
            </div>
    </div>
    }
</div>
